import {
	AttachMoneyRounded,
	BusinessCenterRounded,
	ChatRounded,
	CloseRounded,
	DashboardRounded,
	EmailRounded,
	FeedbackRounded,
	GroupRounded,
	LeaderboardRounded,
	PersonRounded,
	PowerSettingsNewRounded,
	Settings,
	SettingsBackupRestore,
	SettingsBrightness,
	ShoppingCartRounded,
} from '@mui/icons-material';
import { CustomLink } from '../../CustomLink';
import cn from 'classnames';
import './SideBar.css';
import { useState } from 'react';
import { IconButton } from '@mui/material';

const SideBar = ({
	active,
	setSideBarActive,
}: {
	active: boolean;
	setSideBarActive: any;
}) => {
	const [hover, setHover] = useState(false);

	return (
		<nav
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			className={cn(`sidebar`, {
				'mini-sidebar': active === false && hover === false,
				'active-sidebar': active,
			})}
		>
			<div className='sidebar__header'>
				<h2 className='text-2xl md:text-2xl overflow-hidden text-center font-bold font-pacifico'>
					<span
						className={cn(`sidebar__title`, {
							hide: active === false,
						})}
					>
						Dashboard -
					</span>
					TS
				</h2>
				<div className='md:hidden md:fixed'>
					<IconButton
						onClick={() => {
							setSideBarActive(false);
							setHover(false);
						}}
					>
						<CloseRounded className='text-white' />
					</IconButton>
				</div>
			</div>

			<div className='mt-3'>
				<h4 className='text-white px-3 mt-2 text-center'>DASHBOARD</h4>
				<ul>
					<li>
						<CustomLink to='/' className='sidebar__link'>
							<DashboardRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Home
							</span>
						</CustomLink>
					</li>
				</ul>
				<h4 className='text-white px-3 mt-2 text-center'>QUICK MENU</h4>
				<ul>
					<li>
						<CustomLink to='/users' className='sidebar__link'>
							<GroupRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Users
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/products' className='sidebar__link'>
							<ShoppingCartRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Products
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<AttachMoneyRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Transactions
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<LeaderboardRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Reports
							</span>
						</CustomLink>
					</li>
				</ul>
				<h4 className='text-white px-3 mt-2 text-center'>NOTIFICATIONS</h4>
				<ul>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<EmailRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Mail
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<FeedbackRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								FeedBack
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<ChatRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Messages
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<LeaderboardRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Notifications
							</span>
						</CustomLink>
					</li>
				</ul>
				<h4 className='text-white px-3 mt-2 text-center'>STAFF</h4>
				<ul>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<BusinessCenterRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Manage
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<PersonRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Profile
							</span>
						</CustomLink>
					</li>
				</ul>
				<h4 className='text-white px-3 mt-2 text-center'>SETTINGS</h4>
				<ul>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<Settings className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								General Settings
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<SettingsBackupRestore className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Backups
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<SettingsBrightness className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Themes
							</span>
						</CustomLink>
					</li>
					<li>
						<CustomLink to='/404' className='sidebar__link'>
							<PowerSettingsNewRounded className='sidebar__link-icon' />{' '}
							<span className='sidebar__link-text'>
								Logout
							</span>
						</CustomLink>
					</li>
				</ul>
			</div>
		</nav>
	);
};

export default SideBar;
